import "./AcoeNote1.css";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Cookies from "js-cookie";
import axios from "../../axios.jsx";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";

function AcoeNote3() {

  const [scholarDetails, setScholarDetails] = useState(null);
  const [adjudicatorDetails, setAdjudicatorDetails] = useState(null);
  const [educationDetails, setEducationDetails] = useState(null);
  const [approve, setApprove] = useState(false);
  const [vivaDate, setVivaDate] = useState(null);
  const [vivaTime, setVivaTime] = useState("");
  const [vivaMinutesFile, setVivaMinutesFile] = useState("");

  const loc = useLocation();
  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);
  useEffect(() => {
    if (Cookies.get("username") != loc.state.officer) {
      alert("unauthorized to this page")
      logout();
    }
    var data = {
      scholarId: loc.state.id,
      note: loc.state.note
    }
    axios
      .post("/api/get-bospanel-note-pages", data)
      .then((resData) => {
        setScholarDetails(resData.data.panel_data);
        setAdjudicatorDetails(resData.data.adjuticators_data);
        setEducationDetails(resData.data.education_details);
      })
      .catch((e) => {
        alert("can't find bos details");
      });

  }, []);

  const handleFileUpload = async (file) => {
    let form_data = new FormData();
    form_data.append("file", file);
    form_data.append("file_name", "minutes_vivavoice");
    form_data.append("mobile", loc.state.id);
    try {
      const resData = await axios.post("/api/file-upload", form_data);
      if (resData.status === 200) {
        console.log(resData.data["file-name"]);
        setVivaMinutesFile(resData.data["file-name"])
      } else {
        console.log(resData);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function handleSubmit() {
    let reqData = {
      scholarId: loc.state.id,
      status: approve ? "APPROVED" : "REJECTED",
      viva_date: vivaDate,
      viva_time: vivaTime,
      vivaMinutesFile,
      designation: Cookies.get("username"),
      note: loc.state.note
    }
    try {
      const resData = await axios.post("/api/update-bospanel", reqData);
      if (resData.status === 200) {
        console.log(resData.data["file-name"]);
      } else {
        console.log(resData);
      }
    } catch (e) {
      console.log(e);
    }
    alert("success");
  }

  const handleApproveOrReject = (e) => {
    if (e.target.value === "true") {
      document.getElementById("approve").checked = true;
      document.getElementById("reject").checked = false;
      setApprove(true);
    } else {
      document.getElementById("approve").checked = false;
      document.getElementById("reject").checked = true;
      setApprove(false);
    }
  };

  return (
    <>
      {(scholarDetails === null || adjudicatorDetails === null) ? (
        <center>
          <RotateLeftIcon
            sx={{
              fontSize: "3rem",
              margin: "0 auto",
              color: "rgba(0,0,0,0.6)",
              animation: "spin 1s linear infinite",
              "@keyframes spin": {
                "0%": {
                  transform: "rotate(360deg)",
                },
                "100%": {
                  transform: "rotate(0deg)",
                },
              },
            }}
          />{" "}
          Loading Details
        </center>
      ) : (
    <>
      <br />
      <br />
      <center>
        <form enctype="multipart/form-data">
          <div className="whole-body">
            <br />
            <h1>KAKATIYA UNIVERSITY</h1>
            <br />
            <hr />
            <div font-size="15">
              <table className="header-table">
                <tr>
                  <th>SUBJECT :</th>
                  <td>
                    <b> {scholarDetails.subject} </b>-Ph.D.thesis submitted by{" "}
                    <b>Mr/Ms. {scholarDetails.name_of_scholar} -</b> Appointment of{" "}
                    <b>
                      <i>Three Examiners</i>
                    </b>{" "}
                    for Evaluation-Reg.
                  </td>
                </tr>
              </table>
            </div>
            <hr />
            <div className="main-content">
              In compliance with the Approval of the Vice-Chancellor at para(08),
              a letter was issued by thie office vide letter No.{scholarDetails.letter_no1}/E1/Ph.D/KU/
              {scholarDetails.letter_no2}, dated {scholarDetails.letter_date}.
              <br />
              The Ph.D Reports on the Thesis Submitted by{" "}
              <b> Mr./Ms. {scholarDetails.name_of_scholar} </b>in<b> {scholarDetails.subject}</b> have been received
              from the following Examinars:
            </div>
            <br />
            <div className="examinars">
              The Ph.D.Open Viva-Voce of <b>Mr./Ms. {scholarDetails.name_of_scholar} </b> was
              conducted on{" "}
              <b>
                {" "}
                <input type="date" onChange={(e) => setVivaDate(e.target.value)} required /> at{" "}
                <input type="time" onChange={(e) => setVivaTime(e.target.value)} required />
              </b>{" "}
              in the Department of {scholarDetails.subject}, Kakatiya University,
              Warangal.The examiners, <b>{adjudicatorDetails[0].name}</b>(External Examiner),
              {adjudicatorDetails[0].name_of_university}, {adjudicatorDetails[0].state}({scholarDetails.mode}), the Dean, Faculty of
              {adjudicatorDetails[0].department}, the Head Department of {scholarDetails.subject}, the Chairperson
              Board of Studies in {adjudicatorDetails[0].department} and {educationDetails.name_of_supervisour}(Supervisor),
              Department of {scholarDetails.subject}, KU, (Offline)were present.
            </div>
            <br />
            <div className="main-content">
              The examiners were satisfied with the answers given by the
              candidate at the Viva-Voce and recommended for the award of
              Ph.D.Degree in <b> {scholarDetails.subject}</b>
              to the candidate.
              <br />
              <br />
              Kindly see the minutes at Flag 'A'&'B'. <br />
              <br />
              <b>Minutes of Viva-Voce</b> :
              <input
                type="file"
                onChange={(e) => handleFileUpload(e.target.files[0])}
                className="form-control note-inputs"
                required
              />
              <br />
              <br />
              If agreed, the <b> Press Note </b> will be issued   and the result of the candidate will be declared so as to affect from the date of conduct of Viva-Voce and the matter may be placed before the University Executive Council for ratifiction.
              <br />
              <br />
              Submitted for Approval
            </div>
            <div className="footer">
              <div>
                <input
                  onClick={handleApproveOrReject.bind(this)}
                  type="radio"
                  id="approve"
                  defaultChecked={approve ? true : false}
                  style={{ marginRight: 10 }}
                  value="true"
                  required
                />
                <label>Approve</label>
                <input
                  onClick={handleApproveOrReject.bind(this)}
                  type="radio"
                  id="reject"
                  defaultChecked={!approve ? true : false}
                  style={{ marginLeft: 10, marginRight: 10 }}
                  required
                />
                <label>Reject</label>
              </div>
            </div>
            <br />
            <br />
            <br />
            <div>
              <input onClick={handleSubmit} className="btn btn-secondary" required />
            </div>
            <br />
            <br />
            <br />
          </div>
        </form>
      </center>
      <br />
      <br />
    </>)}
    </>
  );
}
export default AcoeNote3;

function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/officers-login";
}
